
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import { Component } from "vue-property-decorator";
import TextFloating from "@/components/input/TextFloating.vue";
import FileInput from "@/components/input/FileInput.vue";
import TicketModel from "@/models/createTicket/TicketModel";
import AttachmentModel from "@/models/createTicket/AttachmentModel";
import ProgressTicketModel from "@/models/createTicket/ProgressTicketModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import api from "@/api";
@Component({
  components: {
    SubHeader,
    TextFloating,
    FileInput,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class CreateTicket extends Vue {
  mounted() {
    this.getDetailTicket(this.$route.params.id);
  }

  infoStep = "Click to select photo or activate camera";
  displayUploadTicket = true;
  isActive = false;
  isActiveDesc = false;

  ticket: TicketModel = new TicketModel();
  listImage: AttachmentModel[] = [];
  progress: ProgressTicketModel = new ProgressTicketModel();

  getDetailTicket(idTicket: string) {
    return new Promise((resolve, reject) => {
      api.ticket
        .getDetailTask(idTicket)
        .then((response) => {
          if (response.data.code === 200) {
            this.ticket = Object.assign({}, response.data.data);
            resolve(response);
          }
        })
        .catch((err) => {
          reject(new Error(err));
        });
    });
  }
  addUploadImgRow() {
    const images = new AttachmentModel();
    this.progress.attachment.push(images);
  }
  removeUploadRow(i: number) {
    this.progress.attachment.splice(i, 1);
  }
  submitProgress() {
    if (this.progress.subject && this.progress.desc && this.ticket.attachment) {
      this.$swal({
        text: "Apakah Anda yakin untuk menyimpan data ini ?",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.value) {
          api.ticket
            .createProgress(this.ticket.id, this.progress)
            .then((response) => {
              if (response.data.code === 200) {
                this.$swal(
                  "Berhasil",
                  "Data Berhasil disetujui",
                  "success"
                ).then(() => {
                  this.cancelCreate();
                });
              } else {
                this.$swal("Peringatan", response.data.message, "warning");
              }
            })
            .catch((err: any) => {
              this.$swal("Error", err?.response?.data?.message, "error");
            });
        }
      });
    }
  }
  cancelCreate() {
    this.progress = new ProgressTicketModel();
    this.$router.push({ path: "/progress/" + this.ticket.id });
  }
  cekDesc() {
    if (this.progress.desc !== "") {
      this.isActiveDesc = true;
    } else if (this.progress.desc === "") {
      this.isActiveDesc = false;
    }
  }
  cekSubject() {
    if (this.progress.subject !== "") {
      this.isActive = true;
    } else if (this.progress.subject === "") {
      this.isActive = false;
    }
  }
}
